import { supabase } from "@/lib/supabase";
import type { UserRole } from "@/lib/types";

interface WelcomeEmailInput {
  email: string;
  name: string;
  role: UserRole;
}

export async function sendWelcomeEmail(input: WelcomeEmailInput) {
  const payload = {
    email: input.email,
    name: input.name,
    role: input.role,
  };

  const { error } = await supabase.functions.invoke("send-welcome-email", {
    body: payload,
  });

  if (error) {
    throw error;
  }
}

